import React, { ComponentProps } from 'react';
import { ImageTypes, TitleImage } from '../../../types/api/ImageType';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';
import { HiddenParam, SonForm, TextParam } from '../../../_lib/Form2';
import { NestedParam } from '../../../_lib/Form2/types/NestedParam';
import { ImageFileParam } from '../../../_lib/Form2/types/FileUploadParam';
import { AspectRatioOption } from '../../../components/molecules/ImageCropper/ImageCropperAspectRatioOptions';

type TitleImageEditProps = {
  image: TitleImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: SonForm<
    NestedParam<
      'imageuploadparams',
      'imageupload',
      | ImageFileParam<'image'>
      | HiddenParam<'width'>
      | HiddenParam<'height'>
      | HiddenParam<'y'>
      | HiddenParam<'x'>
      | TextParam<'alt'>
      | TextParam<'copyright'>
      | TextParam<'caption'>
    >
  >;
  userSelectableAspectRatios?: AspectRatioOption[];
};

export function TitleImageEdit({
  image,
  form,
  cropping,
  viewportSwitch,
  userSelectableAspectRatios,
}: TitleImageEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('TitleImage');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      responsiveType="teaser"
      imageType={ImageTypes.titleImage}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="title-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
      userSelectableAspectRatios={userSelectableAspectRatios}
    />
  );
}

export const TitleImageEditView = asFetchableView(TitleImageEdit);
export type TitleImageEditView = ComponentProps<typeof TitleImageEditView>;
